<mat-dialog-content class="px-0 mx-0">
    <!-- {{roleArtifacts|json}} -->
    <div>
        <div class="header">
            <h2>Application Status Task(s)</h2>
            <div class="overall-stats d-flex justify-content-around rounded-3 py-3">
                <div class="stat">
                    <div class="stat-number">{{total}}</div>
                    <div class="stat-label">Total</div>
                </div>
                <div class="stat">
                    <div class="stat-number">{{outstanding}}</div>
                    <div class="stat-label">Outstanding</div>
                </div>
                <div class="stat">
                    <div class="stat-number">{{completed}}</div>
                    <div class="stat-label">Complete</div>
                </div>
            </div>
        </div>

        <div *ngFor="let roleArtifact of roleArtifacts">
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <div class="role-header w-100 m-3">
                        <div>
                            <div class="role-title mb-3">{{roleArtifact.role}} Requirements</div>
                            <div class="role-counts">{{roleArtifact.total}} Total • {{roleArtifact.outstanding}} Outstanding • {{roleArtifact.completed}} Complete</div>
                            <div class="progress-bar">
                                <div class="progress-fill" [style]="{width: roleArtifact.percent+'%'}"></div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel-header>
                
                <div class="role-content expanded" id="applicant-content">
                    <div class="artifacts-list my-3">
                        <ng-container *ngFor="let artifact of roleArtifact.artifacts">
                            <div class="artifact" [ngClass]="artifact.status">
                                <span>
                                    <mat-icon class="material-symbols-outlined me-1" [ngClass]="artifact.status=='Outstanding' ? 'color-danger' : 'color-success'">
                                        {{artifact.status=='Outstanding'?"error":"check_circle"}}
                                    </mat-icon>
                                </span>
                                <div class="artifact-name">{{artifact.name}} - {{artifact.status}}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
</mat-dialog-content>